import CanaryColony from "../components/Careersfolder/CanaryColony";
import CareersCulture from "../components/Careersfolder/CareersCulture";
import CultureCoreValue from "../components/Careersfolder/CultureCoreValue";
import JoinOurTeam from "../components/Careersfolder/JoinOurTeam";
import Carousel from "../components/Careersfolder/Carousel";

const Careers = () => {
  return (
    <>
      <CareersCulture />
      <CanaryColony />
      <CultureCoreValue />
      <JoinOurTeam />
      <Carousel max={4} />
    </>
  );
};

export default Careers;
